import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash-es';
import { Button } from 'reactstrap';

function NextButtonUI({
  enabledNextBtn = false,
  isLoading = false,
  isSubmitBtn = false,
  isFullWidth = false,
  showDisclaimer = false,
  showLockIcon = false,
  btnText = 'Next',
  onClick = noop,
}) {
  return (
    <div className={classNames('d-flex flex-column', { 'submit-btn text-center': isSubmitBtn })}>
      <Button
        disabled={!enabledNextBtn}
        color={enabledNextBtn ? 'blue-50' : 'secondary'}
        data-testid={isSubmitBtn ? 'submit-btn' : 'next-btn'}
        id={isSubmitBtn ? 'submit-btn' : 'next-btn'}
        className={classNames('text-capitalize size-16 next-button fw-normal', {
          'text-center': isSubmitBtn,
          'px-2_5': !isSubmitBtn,
          'w-100': isFullWidth,
          'text-white': !enabledNextBtn,
        })}
        onClick={onClick}
        {...(isSubmitBtn && { type: 'submit', form: 'prequalify-form' })}
      >
        {showLockIcon && <i className="icon-lock2 size-16 me-0_5" aria-hidden />}
        <span>
          {isLoading ? <i data-testid="next-btn-spinner" className="spinner icon-spinner8" aria-hidden /> : btnText}
        </span>
      </Button>
      <div role="status" aria-live="polite" aria-atomic="true" className="visually-hidden">
        {isLoading ? 'Loading' : ''}
      </div>
      {showDisclaimer && <span className="size-12">No impact to your credit score.</span>}
    </div>
  );
}

NextButtonUI.propTypes = {
  enabledNextBtn: PropTypes.bool,
  isSubmitBtn: PropTypes.bool,
  btnText: PropTypes.string,
  showDisclaimer: PropTypes.bool,
  showLockIcon: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
};

export const NextButton = React.memo(NextButtonUI);
